import React from 'react';
import '../App.css';
import { useForm } from 'react-hook-form';
import { useNavigate,useLocation } from 'react-router-dom';
import { ApiUrl } from '../App';

type FormData = {
};

const Login: React.FC = () => {
  const { handleSubmit } = useForm<FormData>();
  const navigate = useNavigate();

  const location = useLocation();
  let email = location.state.email;
  let pass  = location.state.password;
  console.log(email);
  console.log(pass);
  
 // const onSubmit = handleSubmit((data) => console.log(data));
  const onSubmit = handleSubmit((data) => {
          const formData = new URLSearchParams();
          formData.append("email"   ,email);
          formData.append("password",pass);
          const body = formData.toString();
          fetch( ApiUrl + "auth/email/login", {
  		method: "POST",
		headers:{
			'Content-Type': 'application/x-www-form-urlencoded',
		},
  		body:  body,
		})
	    .then(response => response.json())
    	    .then(data => {
        	    console.log('Success:', data);
		    const fOk: boolean = data.success;
		    if ( fOk ) {
        	        console.log('Success OK:', data);
			const access_token = data.data.token.access_token;
        	        console.log('Success token:', access_token);
	  		navigate('/newinput', {state:{
				email        : email,
				access_token : access_token,
			}})
		    }else{
        	        console.log('in Error:', data);
        	        console.log('in Error:', data.data.response);
	  		navigate('/mes', { state:{
            			message: data.data.response,
          			}})
		    }
    	    })
    	    .catch((error) => {
        	    console.error('Error:', error);
	  	    navigate('/mes' ,{ state:{
	        }})
    	    });
  });

  return (
    <div className="App">
      <center>
      <h1>認証に成功しました。</h1>
      <table width="60%">
      <tr><td>
      <form onSubmit={onSubmit}>
	<br/>
	<center>
        <button type="submit"  color="#f194ff" >
	登録情報を入力するページに進みます。</button>
	</center>
      </form>
      </td></tr>
      <tr><td>
      <center>
      <br/>
      <br/>
      入力ページに進むためのセキュリティトークンを取得します。<br/>
      <br/>
      </center>
      </td></tr>
      </table >
      </center>
    </div>
  );
}

export default Login;
